import camelcaseKeys from "camelcase-keys";
import { Axios } from "../constants/api";
import { TestResult } from "../types/TestResult";

type CreateSupervision = {
  supervisor_id: string;
  result_id: string;
  signed: string;
}
type VerifySupervision = {
  supervisor_id: string;
  supervision_id: string;
  status: "POSITIVE" | "NEGATIVE";
  result_image: string | null;
}

export const getTestResult = (testResultId: string): Promise<TestResult> => {
  return Axios.get(`/results/${testResultId}`).then((response) => {
    const testResult: TestResult = camelcaseKeys(response.data, { deep: true });
    return Promise.resolve(testResult);
  });
};

export const getTest = (testId: string): Promise<any> => {
  return Axios.get(`/tests/${testId}`).then(response => {
    const result = response.data;
    return Promise.resolve(result);
  })
}

export const createSupervision = (supervision: CreateSupervision) => {
  return Axios.post(
    `/supervisor/${supervision.supervisor_id}/result/${supervision.result_id}/`,
    supervision
  );
};
export const verifySupervision = (supervision: VerifySupervision) => {
  return Axios.post(
    `/supervisor/${supervision.supervisor_id}/supervision/${supervision.supervision_id}/`,
    supervision
  );
};
